import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../common/shared.module';

import { NonPlmRecipeRoutingModule } from './non-plm-recipe-routing.module';
import { RecipeWorklistComponent } from './recipe-worklist/recipe-worklist.component';
import { CreateRecipeComponent } from './create-recipe/create-recipe.component';
import { ViewRecipeComponent } from './view-recipe/view-recipe.component';
import { NonPlmRecipeComponent } from './non-plm-recipe.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CanDeactivateGuard } from '../guards/can-deactivate.guard';


@NgModule({
  declarations: [RecipeWorklistComponent, CreateRecipeComponent, ViewRecipeComponent, NonPlmRecipeComponent],
  imports: [
    CommonModule,
    SharedModule,
    NonPlmRecipeRoutingModule,
    ReactiveFormsModule
  ],
  providers: [
    CanDeactivateGuard
  ]
})
export class NonPlmRecipeModule { }
